/*
 * File: cc-cell-item.component.ts                                             *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 22nd December 2021 12:48:17                        *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Monday, 6th March 2023 10:02:21                              *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { CellService } from '../../../services/cell.service';
import { ProductService } from '../../../services/product.service';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ItemDropInterface } from 'app/modules/catalog-cloud/interfaces/item-drop.interface';


import { Product, ProductExtra, ProductVariant, Cell, ProductBase } from '@nousmedis/cc-types';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CcCellAddNoteFormComponent } from '../cc-cell-add-note-form/cc-cell-add-note-form.component';
import { CcCellDetailDialogComponent } from '../cc-cell-detail-dialog/cc-cell-detail-dialog.component';

@Component({
  selector: 'app-cc-cell-item',
  templateUrl: './cc-cell-item.component.html',
  styleUrls: ['./cc-cell-item.component.scss'],
})
export class CcCellItemComponent implements OnInit, OnDestroy, OnChanges {
  // Rastrear el último menú abierto para cerrar anteriores
  private static lastOpenedMenu: any = null;

  @Input() item: ProductBase;
  @Input() height: any;
  @Input() width: any;
  @Input() idPage: string;
  @Input() pageCell: Cell;
  @Input() idCellPage: string;
  @Input() idFascicle: string;
  @Input() idCatalog: string;
  @Input() locked: boolean;

  @Output() remove = new EventEmitter<boolean>();
  @Output() productModelChange = new EventEmitter<string>();
  @Output() productVariantChange = new EventEmitter<ProductVariant>();
  @Output() productExtraChange = new EventEmitter<ProductExtra[]>();

  product: ProductBase;
  currentModel: string;
  currentVariant: ProductVariant;
  currentExtra: ProductExtra[];
  cellMenu: MenuItem[] = [];

  selected: boolean = false;
  imSelected: Subscription = new Subscription();
  imDeleted: Subscription = new Subscription();

  ref: DynamicDialogRef | undefined;
  @ViewChild('menuCell') menuCell: any;

  constructor (
    private productService: ProductService,
    private cellService: CellService,
    private translateService: TranslateService,
    private dialogService: DialogService,
    private renderer: Renderer2
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.item) && (!changes.item.firstChange)) {

      if (changes.item.currentValue != changes.item.previousValue) {
        //this.item = changes.item.currentValue;
        this.productService.getProduct(this.idCatalog, this.item.id).subscribe((product: Product) => {
          this.product = product;
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.imSelected.unsubscribe();
    this.imDeleted.unsubscribe();
  }

  ngOnInit(): void {
    this.currentModel = this.pageCell.productModel;
    this.currentVariant = this.pageCell.productVariant;
    this.currentExtra = this.pageCell.productExtra;

    this.imSelected = this.productService.viewDetails.subscribe(
      (data: Product) => {
        if (data.id != this.item.id) this.selected = false;
        else this.selected = true;
      }
    );

    this.imDeleted = this.productService.dropToListHandler.subscribe((item: ItemDropInterface) => {
      if (item.idCell == this.idCellPage && item.idPage == this.idPage && item.item.id == this.item.id) {
        this.removeIt();
      }
    });
    this.productService.getProduct(this.idCatalog, this.item.id).subscribe((product: Product) => {
      this.product = product ? product : undefined;
    });

    this.setMenuItems();
  }

  removeIt() {
    this.remove.emit(true);
  }

  // openProductForm(e:any)
  // {
  //   // 
  //   this.productService.setProductForm(e);
  // }

  updateModel(e: any) {
    this.currentModel = e;
    this.productModelChange.emit(e);
  }

  updateVariant(e: ProductVariant) {
    this.currentVariant = e;
    this.productVariantChange.emit(e);
  }

  select(item: any) {
    this.productService.selectedProduct(item);
  }

  openExtraForm() {
    console.log("Item: ", this.item);



    //transformar el objeto extraFields a un array de objetos
    //15/06/2025 Javier propone que STATUS y category_parent no se muestren
    const fields = (
      this.currentExtra.length > 0
        ? this.currentExtra
        : Object.entries(this.item.extraFields).map(([key, value]) => ({
          label: key,
          name: key,
          value: value
        }))
    ).filter(field => field.label !== "STATUS" && field.label !== "category_parent" && field.label !== "parent_category" && field.label !== "estatus");


    const extraForm = this.cellService.openExtraFieldsForm(
      fields,
      this.idCatalog,
      this.idFascicle,
      this.idPage,
      this.idCellPage,
      this.pageCell
    );
  }

  setMenuItems() {
    this.cellMenu = [
      {
        label: this.translateService.instant('CRUD.DELETE'),
        icon: 'pi pi-trash',
        command: () => {
          this.removeIt();
        },
      },
      {
        label: this.translateService.instant('PRODUCT.VARIANTS'),
        icon: 'fa fa-clone',
        items: this.setvariantsMenu(),
        disabled: !this.item.variants || this.item.variants.length == 0,
      },
      {
        label: this.translateService.instant('PRODUCT.SELECT_MODEL'),
        icon: 'fa fa-star',
        items: this.setModelsMenu(),
        disabled: !this.item.modelos || this.item.modelos.length == 0,
      },
      {
        label: this.translateService.instant('PRODUCT.EXTRA_FIELDS'),
        icon: 'fa fa-table-list',
        command: () => {
          this.openExtraForm();
        },
      },
      {
        label: this.translateService.instant('CELL.ADD_NOTES'),
        icon: 'fa fa-sticky-note',
        command: () => {
          this.editNotes();
        }
      }

    ];
  }

  setvariantsMenu() {
    let variantsMenu: MenuItem[] = [];
    if (this.item.variants) {
      this.item.variants.forEach((variant: ProductVariant) => {
        variantsMenu.push({
          label: variant.name,
          icon: 'pi pi-pencil'
        });
      });
    }
    return variantsMenu;
  }

  setModelsMenu() {
    let modelsMenu: MenuItem[] = [];
    if (this.item.modelos) {
      if (typeof this.item.modelos == 'string') {
        this.item.modelos.split(',').forEach((model: string) => {
          modelsMenu.push({
            label: model,
            icon: this.currentModel == model ? 'fa fa-star' : 'fa fa-bullseye',
            command: () => {
              this.updateModel(model);
            },
            styleClass: this.currentModel == model ? 'bg-primary-300' : '',

          });
        });
      }
    }
    return modelsMenu;
  }

  onDrag() {
    const itemDrop: ItemDropInterface = { idCell: this.idCellPage, item: this.item, idPage: this.idPage };
    this.productService.dragProduct(itemDrop);
    this.productService.setDroppedProductToList(itemDrop);
  }

  onDragEnd() {

  }

  editNotes() {
    this.ref = this.dialogService.open(CcCellAddNoteFormComponent, {
      header: this.translateService.instant('CELL.ADD_NOTES'),
      width: '400px',
      closable: true,
      dismissableMask: true,
      data: {
        cell: this.pageCell
      }
    });
    this.ref.onClose.subscribe((cell: Cell) => {
      if (!cell) return;
      this.pageCell = cell;
      firstValueFrom(this.cellService.update(this.idCatalog, this.idFascicle, this.idPage, this.pageCell.id, this.pageCell));
    });
  }

  onRightClick(event: MouseEvent, menu: any) {
    event.preventDefault();

    // Cerrar el menú anterior si existe
    if (CcCellItemComponent.lastOpenedMenu && CcCellItemComponent.lastOpenedMenu !== menu) {
      CcCellItemComponent.lastOpenedMenu.hide();
    }

    // Mostrar el nuevo menú
    menu.toggle(event);
    CcCellItemComponent.lastOpenedMenu = menu;

    // Posicionar el menú en las coordenadas exactas del evento del mouse
    setTimeout(() => {
      // Buscar el menú visible (el más reciente agregado al DOM)
      const allMenus = document.querySelectorAll('.p-tieredmenu');
      if (allMenus.length > 0) {
        // El último menú en el DOM debería ser el que acabamos de abrir
        const menuElement = allMenus[allMenus.length - 1];
        this.renderer.setStyle(menuElement, 'position', 'fixed');
        this.renderer.setStyle(menuElement, 'top', event.clientY + 'px');
        this.renderer.setStyle(menuElement, 'left', event.clientX + 'px');
      }
    }, 0);
  }

  showProductDetails() {
    this.ref = this.dialogService.open(CcCellDetailDialogComponent, {
      header: this.item.name,
      width: '800px',
      closable: true,
      dismissableMask: true,
      data: {
        item: this.item,
        product: this.product,
        pageCell: this.pageCell,
        idCatalog: this.idCatalog,
        idFascicle: this.idFascicle,
        idPage: this.idPage,
        idCellPage: this.idCellPage,
        currentModel: this.currentModel,
        currentExtra: this.currentExtra,
      },
    });
    this.ref.onClose.subscribe((result) => {
      if (!result) return;
      this.currentModel = result.model;
      this.currentExtra = result.extraFields;
      this.pageCell = result.pageCell;
      // No emitir eventos: el dialog ya guardó todo en BD via cellService.update()
      // Emitirlos causaría un segundo PUT en cc-cell que sobreescribiría las notas
    });
  }

  sendItemToDetailContainer(): void {
    this.productService.productDetails$.next(this.product);
  };
}